module.exports = __webpack_public_path__ + "media/images/webpage/hotels/2086/room-95b81c2afa83fc6275242cb329f1b647.webp";